module.exports = __webpack_public_path__ + "static/media/20201219_110239_216_IMG_3306.423746f6.jpg";